export default __webpack_public_path__ + "static/media/(42).60f57747.jpg";